import { Controller } from 'lib_ts/enums/routing/controllers';
import { AdminTeamsRoutes } from 'lib_ts/enums/routing/routes/admin-teams';
import { WithID } from 'lib_ts/interfaces/common/i-generics';
import { IServerResponse } from 'lib_ts/interfaces/common/i-server-response';
import { IHitter } from 'lib_ts/interfaces/i-hitter';
import { IAdminTeam, ITeam } from 'lib_ts/interfaces/i-team';
import { BaseRESTService } from 'services/_base-rest.service';

export class AdminTeamsService extends BaseRESTService {
  private static instance: AdminTeamsService;
  static getInstance(): AdminTeamsService {
    if (!AdminTeamsService.instance) {
      AdminTeamsService.instance = new AdminTeamsService();
    }

    return AdminTeamsService.instance;
  }

  private constructor() {
    super({
      controller: Controller.AdminTeams,
    });
  }

  /** get all teams, limited to user's team if not a super admin */
  async getTeams(global: boolean): Promise<IAdminTeam[]> {
    return await this.get({
      uri: AdminTeamsRoutes.GetTeams,
      params: {
        global: global,
      } as any,
    });
  }

  async createTeam(data: Partial<IAdminTeam>): Promise<IServerResponse> {
    return await this.post(
      {
        uri: AdminTeamsRoutes.CreateTeam,
      },
      data
    );
  }

  async updateTeam(
    data: WithID<Partial<IAdminTeam>>
  ): Promise<ITeam | undefined> {
    return await this.put(
      {
        uri: `${AdminTeamsRoutes.UpdateTeam}/${data._id}`,
      },
      data
    )
      .then((result: IServerResponse) => result.data)
      .catch(console.error);
  }

  async importStatsApiHitters(teamID: string): Promise<boolean> {
    return await this.get({
      uri: `${AdminTeamsRoutes.ImportStatsApiHitters}/${teamID}`,
    })
      .then((result: IServerResponse) => result.success)
      .catch((e) => {
        console.error(e);
        return false;
      });
  }

  async getTeamHitters(teamID: string): Promise<IHitter[]> {
    return await this.get({
      uri: `${AdminTeamsRoutes.GetTeamHitters}/${teamID}`,
    })
      .then((result: IServerResponse) => result.data)
      .catch((e) => {
        console.error(e);
        return [];
      });
  }
}
